module.exports = __webpack_public_path__ + "img/1-1ZG015492JX.1f61d152.jpeg";